import formInputsTypes from '../simulatorConstant';
import AxeManuelRMData from './axe/manuel';
import AxeMotoriseRMData from './axe/motorise';
import tablierRideauMetalliqueData from './tablierRM';

import AxeManuel from 'assets/img/axe-manuel.png';
import AxeMotorise from 'assets/img/axe-motorise.png';

import MoteurRideau from 'assets/img/moteur-rideau.png';
import RideauManuelComplet from 'assets/img/rideau-manuel-complet.png';
import RideauMotoriseComplet from 'assets/img/rideau-motorise-complet.png';
import TablierRideau from 'assets/img/tablier-rideau.png';

import RMManuelCompletData from './complet/manuel';
import RMMotoriseCompletData from './complet/motorise';
import RideauMetalliqueMotorisationData from './motorisation';
const RideauMetalliqueData = {
	id: 'RMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Type de Fabrication',
	name: 'RMData',
	className: 'col-lg-12',
	nextStep: false,
	options: [
		{
			id: 11295,
			label: 'Tablier',
			value: 'RMData_Tablier',
			imageUrl: TablierRideau,
			nextStep: tablierRideauMetalliqueData,
			description:
				'Fourniture d’un tablier de rideau métallique, conçu pour assurer la sécurité et la protection des accès, conforme à la norme EN 13241-1.\n'
		},
		{
			id: 11294,
			label: 'Moteur',
			value: 'RMData_Motorisation',
			imageUrl: MoteurRideau,
			nextStep: RideauMetalliqueMotorisationData,
			description:
				"Fourniture d'un moteur de rideau métallique fiable et silencieux qui permet de l'ouvrir et de le fermer en douceur et en silence.\n" +
				'Fabriqué avec des matériaux de haute qualité, conformément à la norme européenne EN 13659.',
		},
		{
			id: 11290,
			label: 'Axe manuel',
			value: 'RMData_AxeManuel',
			imageUrl: AxeManuel,
			nextStep: AxeManuelRMData,
			description:
				"Fourniture d’un axe manuel pour rideau métallique, conçu pour assurer une manœuvre fluide et maîtrisée du tablier.\n" +
				"Solution fiable et durable, garantissant un fonctionnement simple et efficace, conforme à la norme EN 13241-1."

		},
		{
			id: 11291,
			label: 'Axe motorisé',
			value: 'RMData_AxeMotorise',
			imageUrl: AxeMotorise,
			nextStep: AxeMotoriseRMData,
			description:
				"Fourniture d'un axe motorisé de rideau métallique fiable et silencieux qui permet de l'ouvrir et de le fermer en douceur et en silence.\n" +
				'Assure un haut niveau de confort, de sécurité et de fiabilité, conforme à la norme EN 13241-1.',
		},
		{
			id: 11292,
			label: 'Rideau manuel complet',
			value: 'RMData_Manuelcomplet',
			imageUrl: RideauManuelComplet,
			nextStep: RMManuelCompletData,
			description:
				"Fourniture d’un rideau métallique manuel complet, fiable et silencieux qui permet de l'ouvrir et de le fermer en douceur et en silence, comprenant le tablier, l’axe et les éléments de guidage.\n" +
				'Assure un haut niveau de confort, de sécurité et de fiabilité, conforme à la norme EN 13241-1.',
		},
	{
			id: 11293,
			label: 'Rideau motorisé complet',
			value: 'RMData_Motorisecomplet',
			imageUrl: RideauMotoriseComplet,
			nextStep: RMMotoriseCompletData,
			description:
				"Fourniture d’un rideau métallique motorisé complet, fiable et silencieux qui permet de l'ouvrir et de le fermer en douceur et en silence, incluant le tablier, l’axe motorisé et les dispositifs de commande.\n" +
				'Assure un haut niveau de confort, de sécurité et de fiabilité, conforme à la norme EN 13241-1.',
		},
	],

};

export default RideauMetalliqueData;
